import { BaseFeedbackSection } from '@/components';
import { FC } from 'react';
import { useTranslation } from 'next-i18next';

export const OurCustomersSection: FC = () => {
  const { t } = useTranslation('ourData');
  return (
    <BaseFeedbackSection
      title={t('ourCustomers.title')}
      text="Powerlead has transformed our approach to global outreach. Its precision and breadth of data have enabled us to target our efforts more effectively, resulting in more meaningful engagements and a significant increase in booked meetings."
      userRole="CEO Moblers"
      userName="Guy Doron"
      userAvatar="/images/customerAvatars/moblersAuthor.jpeg"
    />
  );
};
